namespace TabAurous.ECommerce {
    export interface ECommOrderPromoForm {
        TransId: Serenity.StringEditor;
        PromoId: Serenity.IntegerEditor;
        ProductTypeId: Serenity.IntegerEditor;
        TotalAmount: Serenity.DecimalEditor;
        PromoPer: Serenity.DecimalEditor;
        PromoAmount: Serenity.DecimalEditor;
    }

    export class ECommOrderPromoForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.ECommOrderPromo';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ECommOrderPromoForm.init)  {
                ECommOrderPromoForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(ECommOrderPromoForm, [
                    'TransId', w0,
                    'PromoId', w1,
                    'ProductTypeId', w1,
                    'TotalAmount', w2,
                    'PromoPer', w2,
                    'PromoAmount', w2
                ]);
            }
        }
    }
}
